let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("16muz")).then(() => parcelRequire('8S2d5'));